import GeneralTracker from '../GeneralTracker';


export default class AuthenticationTracker extends GeneralTracker {
  CAPTURE_NAME = 'session:user:authentication';
  DATALAYER = true;
  VERSION = '1';

  constructor() {
    super();

    if (!window.dataLayer) {
      window.dataLayer = [];
    }
  }

  setHandlers() {
    const service = this.getService();
    service.on('authenticate', this.onAuthentication);
  }

  onAuthentication = (payload) => {
    let user = { 'User Level': payload.accessLevel };

    if (payload.affiliateCode) {
      user = {
        ...user,
        'Advertising Code': payload.affiliateCode,
      };
    }

    if (payload.username) {
      user = {
        ...user,
        Gender: payload.gender,
        Sexuality: payload.genderPreference,
        Member: 'yes',
        'Logged In': 'yes',
        Username: payload.username,
        Created: payload.created,
        'Has Membership Bonus': payload.paymentInfo?.hasMembershipBonus || false,
        'Has Purchases': payload.paymentInfo?.hasPurchases || false,
        'Is Performer': Boolean(payload.isPerformer),
        uid: payload.gaUserUid,
      };
    }

    this.track(user);

    const service = this.getService();
    service.save('user', user);

    this.track({ event: 'user.auth' });
  };
}
